import styled from 'react-emotion';
import { css } from 'emotion';

export const Instruction = styled.div`
  ${({ theme }) => `
    font-size: 16px;
    color: ${theme.color.black1};
  `}
  margin-bottom: 22px;
  margin-top: 7px;
`;

export const LessonItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: none;
  margin-bottom: 18px;
  cursor: pointer;
`;

export const LessonGlobalPosition = styled.span`
  ${({ theme }) => `
    background: ${theme.color.accentBackground};
    color: ${theme.color.black2};
  `}
  font-family: 'ProximaNova-Semibold', sans-serif;
  border-radius: 4px;
  font-size: 12px;
  letter-spacing: 0.9px;
  padding: 4px;
`;

export const LessonName = styled.span`
  ${({ theme }) => `
    color: ${theme.color.black1};
  `}
  font-family: 'ProximaNova-Semibold', sans-serif;
  font-size: 16px;
  margin-left: 8px;
`;

export const RemainingText = styled.span`
  ${({ theme }) => `
    color: ${theme.color.black3};
  `}
  font-family: 'ProximaNova', sans-serif;
  font-size: 16px;
  margin-left: 10px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;

export const popupBodyClassName = css`
  max-height: 50vh;
  overflow: auto;
`;
